import { Box, Divider, Typography } from "@mui/material"
import { NOT_FOUND_CONTAINER } from "."

export const NotFoundPage = () => {
    return <Box sx={NOT_FOUND_CONTAINER} >
        <Typography variant="h2">
            404
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ border: "2px solid black", marginInline: 5 }} />
        <Typography variant="h3" color="text.secondary">
            Page non trouvée !
        </Typography>
    </Box>
}